import { ArrowDownOutlined } from '@ant-design/icons';
import React, { useEffect, useRef, useState } from 'react';
import { addClassName, checkLimit, getElById, removeClassName } from "../../../../util/varibles/global";
import styles from './style.module.scss';

const LIMIT = 15, SHOW_BUTTON = 80;
const RowResize: React.FC = () => {
    const [isDrag, setIsDrag] = useState(false)
    const [isTop, setIsTop] = useState(false)
    const rootRef = useRef<HTMLDivElement>(null);
    const beforeRef = useRef<HTMLDivElement>();
    const afterRef = useRef<HTMLDivElement>();
    const resizeRef = useRef({
        relY: 0,
        planBeforeHeight: 0,
        maxHeight: 0,
    });

    useEffect(() => {
        const el = rootRef.current;
        if (!el)
            return;
        const beforeEl = getElById('biology')
        if (beforeEl)
            beforeRef.current = beforeEl as HTMLDivElement;
        const afterEl = document.getElementById('plan');
        if (afterEl)
            afterRef.current = afterEl as HTMLDivElement;

        const handleResizeMouseDown = (e: any) => {
            if (!beforeRef.current || !afterRef.current) return;
            document.addEventListener('mousemove', handleResizeMouseMove);
            document.addEventListener('mouseup', handleResizeMouseUp);
            addClassName(document.body)
            const bodyPlanElement = document.getElementById('container-plan');
            resizeRef.current.relY = e.pageY;
            resizeRef.current.planBeforeHeight = beforeRef.current.offsetHeight;
            resizeRef.current.maxHeight = bodyPlanElement?.offsetHeight || 0
            setIsDrag(true)
        };

        const handleResizeMouseMove = (e: any) => {
            let { pageY } = e;
            let beforeHeight = resizeRef.current.planBeforeHeight + pageY - resizeRef.current.relY;
            beforeHeight = checkLimit(LIMIT, resizeRef.current.maxHeight - LIMIT, beforeHeight);
            const afterHeight = resizeRef.current.maxHeight - beforeHeight;
            if (beforeRef.current) {
                beforeRef.current.style.height = beforeHeight + 'px';
                beforeRef.current.dataset.isDrag = 'true';
            }
            if (afterRef.current) {
                afterRef.current.style.height = afterHeight + 'px';
                afterRef.current.dataset.isDrag = 'true';
            }
            setIsTop(beforeHeight <= SHOW_BUTTON)
        };

        const handleResizeMouseUp = () => {
            removeClassName(document.body);
            document.removeEventListener('mousemove', handleResizeMouseMove);
            document.removeEventListener('mouseup', handleResizeMouseUp);
            if (beforeRef.current)
                delete beforeRef.current.dataset.isDrag;
            if (afterRef.current)
                delete afterRef.current.dataset.isDrag;
            setIsDrag(false)
        };

        el.addEventListener('mousedown', handleResizeMouseDown);

        const planBeforeElement = document.getElementById('biology');
        if (planBeforeElement && planBeforeElement.offsetHeight <= SHOW_BUTTON) {
            setIsTop(true)
        }

        return () => {
            if (beforeEl)
                delete beforeEl.dataset.isDrag;

            if (afterEl)
                delete afterEl.dataset.isDrag;
            if (el)
                el.removeEventListener('mousedown', handleResizeMouseDown);
        }
    }, []);

    const handlePointerClick = () => {
        const planBeforeElement = document.getElementById('biology');
        const planAfterElement = document.getElementById('plan');

        if (!planBeforeElement || !planAfterElement) return;

        const parentHeight = planBeforeElement.parentElement?.clientHeight || 0;
        const currentPercent = (planBeforeElement.offsetHeight / parentHeight) * 100;
        if (currentPercent <= 28 || currentPercent >= 68) {
            planBeforeElement.style.height = 'calc(30% - 2px)';
            planAfterElement.style.height = 'calc(70% - 2px)';
            setIsTop(false);
        } else {
            planBeforeElement.style.height = '60px';
            planAfterElement.style.height = 'calc(100% - 64px)';
            setIsTop(true);
        }
    }

    return <div ref={rootRef} className='relative' data-is-drag={isDrag}>
        <div className={styles.resize} />
        <div className={styles.pointer} data-is-top={isTop} onClick={handlePointerClick} >
            <span>Site window</span>
            <ArrowDownOutlined style={{ transition: 'all .3s', transform: isTop ? 'rotate(0deg)' : 'rotate(180deg)' }} />
        </div>
    </div>;
};

export default RowResize;